import TipsForm from "@/components/feature/TipsForm";
import { siteInfo } from "@/mocks/site";

const contactItems = [
  { icon: "ri-mail-send-line", label: "线索投递", value: siteInfo.tipsEmail },
  { icon: "ri-customer-service-2-line", label: "内容更正与合作", value: siteInfo.email },
  { icon: "ri-shield-check-line", label: "投稿方式", value: "表单投递默认匿名，仅用于材料核对" },
];

export default function TipOffSection({ id = "tips" }: { id?: string }) {
  return (
    <section id={id} className="w-full bg-background-100 border-y border-background-200">
      <div className="px-4 md:px-8 py-14 md:py-20 grid grid-cols-1 lg:grid-cols-12 gap-8">
        <div className="lg:col-span-5">
          <p className="flex items-center gap-2 text-xs font-medium tracking-widest text-primary-600 uppercase">
            <span className="inline-block w-6 h-px bg-primary-500" />
            Tip Off
          </p>
          <h2 className="mt-3 font-heading text-xl md:text-3xl font-bold text-foreground-950">
            有料要爆？把线索投进来
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
            提供线索时，时间、出处与可核对的材料比情绪更重要。写得越具体，核对越快，形成的证据链也越完整。
          </p>

          <ul className="mt-8 flex flex-col gap-4">
            {contactItems.map((item) => (
              <li key={item.label} className="flex items-start gap-3.5">
                <span className="flex w-10 h-10 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-800">
                  <i className={`${item.icon} text-lg`} />
                </span>
                <div className="min-w-0">
                  <p className="text-sm font-medium text-foreground-800">{item.label}</p>
                  <p className="mt-0.5 text-sm text-foreground-600 break-all">{item.value}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-7">
          <TipsForm />
        </div>
      </div>
    </section>
  );
}